import gql from "graphql-tag";

export default async function intercom({ next }) {
	try {
		let response = await window.apolloClient.query({
			query: gql`
				{
					User {
						id
						first_name
						last_name
						email
						created_at
						ParentCompany {
							id
							name
						}
					}
				}
			`
		});

		let user = response.data.User;

		window.Intercom("update", {
			Origin: "platform-v3",
			name: `${user.first_name} ${user.last_name}`,
			first_name: user.first_name,
			last_name: user.last_name,
			email: user.email,
			user_id: user.id,
			created_at: new Date(user.created_at).getTime() / 1000,
			environment: process.env.NODE_ENV,
			company: user.ParentCompany
		});
	} catch (e) {
		console.error("Intercom error");
	}

	return next();
}
